import React, { useEffect, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import PageNavContainer from '../../../state/PageNavContainer'
import OnboardingWelcomePage from './OnboardingWelcomePage'

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `onboarding-welcome`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const OnboardingWelcomeModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      backgroundIsHidden: true,
      accoundNavIsHidden: true,
    })
  }, [setNav])

  useEffect(() => {
    if (loaderData?.page?.meta?.title) {
      document.title = loaderData.page.meta.title
    }
  }, [loaderData])

  return <OnboardingWelcomePage content={loaderData.page.content} />
}

export default OnboardingWelcomeModule
